export function isConflictError(error) {
  return Number(error?.response?.status) === 409;
}

export function isBoundaryOverlapError(error) {
  const data = error?.response?.data || {};
  return isConflictError(error) && (data.error === "FIELD_BOUNDARY_OVERLAP" || data.detail?.error === "FIELD_BOUNDARY_OVERLAP");
}

export function readApiErrorDetail(error) {
  const data = error?.response?.data;

  if (typeof data === "string") {
    return data;
  }

  if (typeof data?.detail === "string") {
    return data.detail;
  }

  if (typeof data?.message === "string") {
    return data.message;
  }

  if (typeof data?.error === "string") {
    return data.error;
  }

  return "";
}

export function duplicateNameMessage(
  error,
  {
    resourceLabel = "record",
    name = "",
    scope = "",
    fallback = "",
  } = {}
) {
  if (!isConflictError(error)) {
    return fallback;
  }

  const apiDetail = readApiErrorDetail(error);
  const normalizedName = String(name || "").trim();
  const namedRecord = normalizedName
    ? `${resourceLabel} named "${normalizedName}"`
    : resourceLabel;
  const scopedMessage = scope ? ` ${scope}` : "";

  if (apiDetail && /already exists/i.test(apiDetail)) {
    return apiDetail;
  }

  return `A ${namedRecord} already exists${scopedMessage}. Use a different name or edit the existing ${resourceLabel}.`;
}
